module.exports = "/_next/static/images/T1_hires-950780d7afc7f266c450ea0faef10dda.png";